import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Header from '../components/Header';
import SEO from '../components/SEO';

const AuthCallbackPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    const userStr = searchParams.get('user');
    const err = searchParams.get('error');
    if (err) {
      setError(err === 'google_denied' ? 'Google sign-in was cancelled.' : 'Something went wrong. Please try again.');
      return;
    }

    if (!token) {
      setError('No authentication token received.');
      return;
    }

    // Store token and user
    localStorage.setItem('esanza_buyer_token', token);

    if (userStr) {
      try {
        const user = JSON.parse(decodeURIComponent(userStr));
        localStorage.setItem('esanza_buyer_user', JSON.stringify(user));
      } catch { /* ignore parse errors */ }
    }

    // Redirect to marketplace
    navigate('/buy', { replace: true });
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen bg-gray-50">
      <SEO title="Signing in..." description="Completing Google sign-in" />
      <Header />

      <div className="flex items-center justify-center px-4 py-16">
        <div className="w-full max-w-md text-center">
          {error ? (
            <>
              <div className="w-16 h-16 bg-red-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <span className="text-3xl">⚠️</span>
              </div>
              <h1 className="text-2xl font-extrabold text-gray-900 mb-2">Sign-in failed</h1>
              <p className="text-gray-500 mb-6">{error}</p>
              <a
                href="/login"
                className="inline-block px-6 py-3 rounded-xl font-bold bg-gradient-to-r from-emerald-500 to-green-600 text-white hover:from-emerald-600 hover:to-green-700 shadow-lg transition-all"
              >
                Back to Login
              </a>
            </>
          ) : (
            <>
              <div className="w-16 h-16 bg-emerald-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <div className="w-8 h-8 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin"></div>
              </div>
              <h1 className="text-2xl font-extrabold text-gray-900 mb-2">Signing you in...</h1>
              <p className="text-gray-500">Connecting with Google securely.</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthCallbackPage;
